import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 28766FCF-01FB-43EF-AAE4-B78A644880AF
 * name invoice-import
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-import.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceImportIcon = createSvgIcon(<><path d="M18 20L21 22V3H3V11H12.67L10.08 8.41L11.5 7L16.5 12L11.5 17L10.08 15.58L12.67 13H3V22L6 20L9 22L12 20L15 22L18 20Z" /></>, 'InvoiceImportIcon');
export default InvoiceImportIcon